import { select } from 'redux-saga/effects';
import { call, put } from 'store/utils';
import { createClassMeeting, hasMeetingBeenCreated, isMeetingRunning } from 'utils/apiCalls';
import * as moodleActions from './moodleActions';
import ClassMode from 'enums/ClassMode';

export function* checkClassSaga(push, meetingName, externalMeetingId) {
  yield put(moodleActions.initAction({ key: 'checkClass' }));
  try {
    const { classMode, userId } = yield select(({ user }) => ({
      classMode: user.classMode,
      userId: user.userId,
    }));

    if (!classMode || !userId) {
      throw Error({ message: 'No user info found!' });
    }

    if (classMode === ClassMode.Teacher) {
      const meetingCreated = yield call(hasMeetingBeenCreated, externalMeetingId);
      if (!meetingCreated?.isCreated) {
        yield call(createClassMeeting, externalMeetingId, userId, meetingName);
      }
      push(`/classroom?title=${encodeURIComponent(externalMeetingId)}`);
    } else {
      if (yield call(isMeetingRunning, externalMeetingId)) {
        push(`/classroom?title=${encodeURIComponent(externalMeetingId)}`);
      } else {
        yield put(moodleActions.setMeetingHasNotStartedAction(true));
      }
    }

    yield put(moodleActions.successAction({ key: 'checkClass' }));
  } catch (error) {
    yield put(moodleActions.errorAction({ key: 'checkClass', error }));
  }
}
